import type { FormEvent, ReactNode } from "react";
import Button from "ui/buttons/Button";
import Modal, { type ModalProps } from "ui/components/Modal";

interface AdminModalProps extends Omit<ModalProps, "open"> {
  children: ReactNode;
  headerText: string;
  onSubmit?: (event: FormEvent<HTMLFormElement>) => void;
  disabled?: boolean;
  submitButtonText?: string;
}

export default function AdminModal({
  headerText,
  onSubmit,
  disabled,
  submitButtonText = "Submit",
  children,
  ...props
}: AdminModalProps) {
  return (
    <Modal
      open
      title={headerText}
      footer={
        <>
          {" "}
          <Button type="button" btnStyle="tertiary" btnSize="large" onClick={props.onClose}>
            Cancel
          </Button>
          <Button type="submit" btnStyle="primary" btnSize="large" disabled={disabled} form={headerText}>
            {submitButtonText}
          </Button>
        </>
      }
      size="small"
      variants={["bodyPadding", "footerButtons"]}
      {...props}
    >
      <>
        {onSubmit ? (
          <form onSubmit={onSubmit} id={headerText} style={{ width: "100%" }}>
            {children}
          </form>
        ) : (
          children
        )}
      </>
    </Modal>
  );
}
